import * as React from 'react';
import Grid from "@mui/material/Grid";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useState, useEffect} from "react";
import useRootHook from "../../hooks/useRoot";
import helpers from "../../helpers/common";
import NewsForm from "./NewsForm";
import news from "../../models/news";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function NewsEdit(props) {
    const {setShowLoader} = useRootHook()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const [errors, setErrors] = useState({});
    const [fields, setFields] = useState({enabled: true})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const id = searchParams.get('id')
        if (!id) {
            navigate('/news')
            return
        }

        setShowLoader(true)
        setLoading(true)
        news.get(id)
            .then((data) => {
                if (data) {
                    setFields({
                        id: data.id,
                        title: data.title || '',
                        content: data.content || '',
                        enabled: data.enabled !== undefined ? data.enabled : true
                    })
                }
                setShowLoader(false)
                setLoading(false)
            }).catch(() => {
                setShowLoader(false)
                setLoading(false)
                navigate('/news')
            })
    }, [searchParams, navigate, setShowLoader])

    const handleChange = (ev) => {
        const [, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            if (name === 'enabled') {
                newFields[name] = ev.target.checked;
            } else {
                newFields[name] = value;
            }

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [, , name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        // Валидация будет через methodValidator
        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = news.methodValidator.edit(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        news.edit(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/news')
            }).catch(() => setShowLoader(false))
    }

    if (loading) {
        return null
    }

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title="Edit news" breadcrumbs={[['Dashboard', '/'], ['News', '/news'], ['Edit', '/news/edit']]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <NewsForm fields={fields} errors={errors} handleChange={handleChange}
                           handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}

